<div [tp]="JobTaskStateTooltipComponent" [tpData]="$jobTask()" tpVariation="light">
    <span [class]="jobTaskStateColor($jobTask()?.state ?? null)" class="cm-thumbnail">
        @if ($progress() !== null) {
            <svg class="cm-progress-ring" viewBox="0 0 36 36" aria-hidden="true">
                <circle class="cm-progress-ring-track" cx="18" cy="18" r="16" pathLength="100"></circle>
                <circle
                    class="cm-progress-ring-value"
                    cx="18"
                    cy="18"
                    r="16"
                    pathLength="100"
                    [style.stroke-dasharray]="$progress()! + ' ' + (100 - $progress()!)"
                ></circle>
            </svg>
        }
        @if ($jobTask()?.state) {
            <i class="cm-job-thumbnail-icon" [class]="jobTaskStateIconClass($jobTask())"></i>
        } @else {
            <i class="fa-thin fa-question-circle" [style.color]="'#d0d0d0'"></i>
        }
    </span>
</div>
